import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/** Legacy route: account settings now live under Settings → Personal → Profile. */
const UserSettings = () => {
  const { team } = useParams();
  if (!team) return null;
  return <Navigate to={`/${encodeURIComponent(team)}/settings/profile`} replace />;
};

export default UserSettings;
